<div
  class="resize-container-6 h-screen flex relative lg:static bg-surface-0 dark:bg-surface-950 overflow-hidden"
>
  <p-toast></p-toast>
  <app-sidebar></app-sidebar>
  <div class="flex flex-col flex-auto h-full overflow-hidden">
    <div
      class="flex justify-between items-center shrink-0 bg-surface-0 dark:bg-surface-950 mr-2"
    >
      <div class="flex items-center gap-8">
        <a
          pStyleClass="#app-sidebar-10"
          enterFromClass="hidden"
          enterActiveClass="animate-fadeinleft"
          leaveToClass="hidden"
          leaveActiveClass="animate-fadeoutleft"
          [hideOnOutsideClick]="true"
          [hideOnResize]="true"
          resizeSelector=".resize-container-6"
          class="cursor-pointer flex items-center justify-center lg:hidden text-surface-700 dark:text-surface-100"
        >
          <i class="pi pi-bars text-xl! leading-none!"></i>
        </a>
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="card flex">
        <p-select
          [options]="userLocations"
          size="small"
          [(ngModel)]="selectedUserLocation"
          optionLabel="locationName"
          placeholder="User Location"
          class="w-40 md:w-40 text-sm"
          (ngModelChange)="onUserLocationChange($event)"
        >
          <ng-template pTemplate="selectedItem" let-location>
            @if (location) {
              <div class="flex align-items-center gap-2">
                <i class="pi pi-map-marker text-primary"></i>
                <span>{{ location.locationName }}</span>
              </div>
            }
          </ng-template>

          <ng-template pTemplate="item" let-location>
            <div class="flex align-items-center gap-2">
              <i class="pi pi-map-marker text-500"></i>
              <span>{{ location.locationName }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>
    <div class="flex-auto overflow-y-auto p-2">
      <div
        class="border-2 border border-surface-100 dark:border-surface-700 rounded-2xl bg-surface-50 dark:bg-surface-900 h-full"
      >
        <div class="h-full overflow-y-auto p-4 bg-primary-50">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
